<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="row container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <div v-if="formType == 'edit'">
              Editar {{ equipment }} {{ oldName }}
            </div>
            <div v-else>Adicionar {{ equipment }}</div>
          </div>
          <div class="sensors-general pl-3 pr-3">
            <b-form-text id="input-name">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Nome *"
              :formatter="notEmpty"
              maxlength="24"
              size="sm"
              id="input-name"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text id="input-model">Modelo *</b-form-text>
            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <searchable-select
              v-model="form.FK_MODEL"
              :options="sensorsModels"
              text-field="NAME"
              value-field="ID"
              :state="modelState"
              :clearable="false"
              placeholder="Selecione o modelo *"
            />
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>

          <div class="pl-3 pr-3">
            <div class="group-inputs-title">Localização</div>
            <b-form-text>Latitude </b-form-text>
            <b-form-text v-show="form.LATITUDE">Latitude</b-form-text>
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="Latitude"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
            />
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text>Latitude </b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="Longitude"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
            />
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>
          </div>

          <div v-if="form.FK_MODEL != null">
            <div class="pl-3 pr-3">
              <div class="group-inputs-title">Medições</div>
              <span class="error" v-if="!minMaxState">
                Existem valores inválidos para máximo e mínimo de medições!
                Todos os campos de máximo de mínimo são obrigatórios. Permitidos
                apenas números, um único ponto decimal e um único hífen
                indicando valor negativo.
              </span>
              <div v-for="(r, index) in range" :key="r.POS" class="sensors-measures" :class="`${index ? 'mt-5' : ''}`">
                <div>
                  MEDIÇÃO {{ r.POS + 1 }} - {{ r.TYPE_NAME }} ({{
                    r.UNIT_NAME
                  }})
                </div>
                <b-form-text v-show="r.MIN_VALUE">Mínimo *</b-form-text>
                <b-form-input
                  v-model="r.MIN_VALUE"
                  placeholder="Mínimo *"
                  :formatter="maxMin"
                  size="sm"
                  maxlength="20"
                />
                <b-form-text v-show="r.MAX_VALUE">Máximo *</b-form-text>
                <b-form-input
                  v-model="r.MAX_VALUE"
                  placeholder="Máximo *"
                  :formatter="maxMin"
                  maxlength="20"
                  size="sm"
                />
              </div>
            </div>
          </div>
          <div class="pl-3 pr-3">
            <div class="group-inputs-title">Extra</div>
            <b-form-text id="input-obs">Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              id="input-obs"
              size="sm"
            />
            <b-form-checkbox v-model="form.ANA_TELEMETRY" class="mt-2" size="sm">
              Telemetria ANA
            </b-form-checkbox>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="closeForm"
          class="mr-1 ml-2"
        >
          Fechar
        </b-btn>
        <b-btn
          block
          variant="3v3"
          @click="checkForm"
          size="sm"
          class="ml-1 mr-2"
        >
          Salvar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "sensor-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    sensorsModels: Array,
    auxSensors: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        RANGE: [],
        NOTE: null,
        ANA_TELEMETRY: false,
      },
      range: [],
      firstFKModelChange: false,
      minMaxState: true,
    };
  },
  watch: {
    "form.FK_MODEL": {
      handler(oldValue, newValue) {
        if (this.form.FK_MODEL && this.sensorsModels.length) {
          let search = this.form.FK_MODEL;
          try {
            let select = this.sensorsModels.filter((i) => i.ID == search)[0]
              .MEASURES;
            //Trocando de MODEL
            if (newValue && newValue !== oldValue) {
              this.range = select;
              this.form.RANGE = [];
            }
            if (!this.firstFKModelChange) {
              this.range = select;
              this.firstFKModelChange = false;
            }
          } catch (e) {
            console.log(e);
          }
        }
      },
    },
    /*"form.FK_MODEL": function () {
      if (this.form.FK_MODEL && this.sensorsModels.length) {
        let search = this.form.FK_MODEL;
        try {
          let select = this.sensorsModels.filter((i) => i.ID == search)[0]
            .MEASURES;
          if (!this.firstFKModelChange) {
            this.range = select;
            this.firstFKModelChange = false;
          }
        }
      }
    },*/
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.firstFKModelChange = true;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.range = this.itemToEdit.RANGE;
          this.form.NOTE = this.itemToEdit.NOTE;
          this.form.ANA_TELEMETRY = !!this.itemToEdit.ANA_TELEMETRY;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    closeForm() {
      this.resetForm();
      this.$emit("close-form");
    },
    notEmpty(value) {
      return notEmpty(value);
    },
    maxMin(value) {
      let regex = /^[0-9_.-]*$/;
      if (value && value != "") {
        if (regex.test(value)) return value;
      }
      return null;
    },
    resetForm() {
      this.firstFKModelChange = false;
      this.range = [];
      this.form = {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        RANGE: [],
        NOTE: null,
        ANA_TELEMETRY: false,
      };
      this.minMaxState = true;
    },
    checkRange() {
      let len = this.range.length;
      let count = 0;
      for (let i = 0; i < len; i++) {
        if (
          this.range[i].MIN_VALUE != undefined &&
          `${this.range[i].MIN_VALUE}` != "" &&
          this.range[i].MAX_VALUE != undefined &&
          `${this.range[i].MAX_VALUE}` != ""
        ) {
          count++;
          this.range[i].MIN_VALUE = Number(this.range[i].MIN_VALUE);
          this.range[i].MAX_VALUE = Number(this.range[i].MAX_VALUE);
        }
      }
      if (count < len) {
        this.minMaxState = false;
        return false;
      } else return true;
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate,
        this.checkRange(),
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipmamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        "Existem valores inválidos para máximo e mínimo de medições! Todos os campos de máximo de mínimo são obrigatórios. Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE = !!this.form.LATITUDE
        ? parseFloat(this.form.LATITUDE)
        : null;
      this.form.LONGITUDE = !!this.form.LONGITUDE
        ? parseFloat(this.form.LONGITUDE)
        : null;
      this.form.RANGE = this.range;
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
.sensors-measures > div {
  font-size: 0.8em;
}
#form {
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form {
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0em;
    margin-right: 0;
  }
}
</style>
